// Minimal frontend entrypoint for the rewrite track.
// Keep this file small and explicit; add feature modules gradually.
import { installLegacyBridge } from "./legacy-bridge";
import { installContextMenuTriggers } from "./context-menu/long-press";

function bootstrap(): void {
  document.documentElement.classList.add("js-enabled");
  installLegacyBridge();
  const calendar = document.getElementById("calendar");
  if (calendar) installContextMenuTriggers(calendar);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootstrap, { once: true });
} else {
  bootstrap();
}
